import { useEffect, useState } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { CheckOutlined, EditOutlined } from "@ant-design/icons";
import { Switch } from "antd";

import Fetch from "components/Fetch";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import DeleteButton from "components/buttons/DeleteButton";
import FinishButton from "components/Modals/ManageAccounts/FinishButton";
import Loading from "components/App/Loading";
import ManagePayment from "components/Modals/ManageAccounts";
import Table from "components/Tables/Table";
// import Filters from "components/dashboard/Filters";
import { getThemeState } from "state/selector";
import { states } from "constants/app";
import { GlassCard } from "components/App/styled";

const Filters = ({ setStatus, reload }) => (
  <div style={{ marginTop: 32 }}>
    نمایش همه :
    <Switch
      style={{ marginRight: 8 }}
      onChange={(state) => {
        reload(true);
        setStatus(state ? "" : "/accounts");
      }}
    />
  </div>
);

function Index(props) {
  console.log("theme", props.theme);
  const [data, setData] = useState(false);
  const [reload, setReload] = useState(false);
  const [orders, setOrders] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [status, setStatus] = useState("/accounts");

  console.log("dashboard/index data", status);
  useEffect(() => {
    Fetch.get(`/orders${status}`, (res) => {
      console.log("orders", res);
      if (res) {
        setOrders(res.orders);
        setData(res);
        setReload(false);
      }
    });
  }, [reload, status]);

  function handleUpdate(index) {
    setUpdateModal(orders[index]);
  }

  if (!data) {
    return <Loading />;
  }
  return (
    <Container>
      {/* <CardsContainer>
        <StatusCard
          color={colors.secondary}
          textColor="#444"
          value={orders.filter((item) => item.state === 0).length}
          text="در حال پردازش"
          link=""
        />
        <StatusCard
          color="#3A4041"
          textColor="#fff"
          value="0000"
          text="در انتظار ارسال"
          link=""
        />
        <StatusCard
          color="#E8E8E8"
          textColor="#444"
          value={orders.filter((item) => item.stock === 0).length}
          text="کالا های بدون موجودی"
          link=""
        />
      </CardsContainer> */}

      <GlassCard style={{ padding: "16px 4px", marginBottom: 32 }}>
        {updateModal && (
          <ManagePayment
            reload={setReload}
            data={data}
            oldData={updateModal}
            visible={updateModal ? true : false}
            setVisible={setUpdateModal}
            buttonStyle={{ display: "none" }}
          />
        )}
        <Filters
          data={data}
          orders={orders}
          setOrders={setOrders}
          setStatus={setStatus}
          reload={setReload}
        />
      </GlassCard>
      <TableContainer>
        <Table
          loading={reload}
          columns={tableHeaders}
          dataSource={orders?.map((item, index) => ({
            ...item,
            state: states[item.state].icon,
            actions:
              item.state === 3 ? (
                <div className="center">
                  پایان یافته
                  <CheckOutlined
                    style={{ color: colors.green, fontSize: 18 }}
                  />
                </div>
              ) : (
                <div className="center row">
                  <FinishButton data={item} reload={setReload} />
                  <Button
                    style={{ marginRight: 6 }}
                    onClick={() => handleUpdate(index)}
                  >
                    <EditOutlined />
                  </Button>
                  <DeleteButton
                    id={item.id}
                    reload={setReload}
                    title="سفارش"
                    link="orders"
                  />
                </div>
              ),
            key: index + 1,
          }))}
        />
      </TableContainer>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const theme = getThemeState(state);
  return { theme };
};
export default connect(mapStateToProps)(Index);
const Container = styled.div`
  color: ${colors.dark};
`;

const TableContainer = styled.div``;
const tableHeaders = [
  {
    title: "شمار",
    dataIndex: "key",
    key: "key",
    align: "center",
    width: "80px",
  },
  {
    title: "نام مشتری",
    dataIndex: "customer",
    key: "customer",
    align: "center",
  },
  { title: "نام فروشگاه", dataIndex: "shop", key: "shop", align: "center" },
  { title: "آدرس", dataIndex: "address", key: "address", align: "center" },
  { title: "تلفن", dataIndex: "phone", key: "phone", align: "center" },
  { title: "ویزیتور", dataIndex: "visitor", key: "visitor", align: "center" },
  { title: "مرحله", dataIndex: "state", key: "state", align: "center" },
  { title: "اعمال", dataIndex: "actions", key: "actions", align: "center" },
];
